import { render, staticRenderFns } from "./stockDetails.vue?vue&type=template&id=d483d852"
import script from "./stockDetails.vue?vue&type=script&lang=js"
export * from "./stockDetails.vue?vue&type=script&lang=js"
import style0 from "./stockDetails.vue?vue&type=style&index=0&id=d483d852&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports